"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scale = void 0;
var scale_1 = require("@antv/scale");
Object.defineProperty(exports, "Scale", { enumerable: true, get: function () { return scale_1.Scale; } });
//# sourceMappingURL=interface.js.map